/**
 * Get the extension from a filename
 */
export default function getFileExtension(filename: string): string {
  const lastIndex = filename.lastIndexOf('.');
  return filename.substring(lastIndex + 1);
}
